var Email, Model, config, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Model = require('models/base/model');

config = require('config');

module.exports = Email = (function(_super) {
  __extends(Email, _super);

  function Email() {
    _ref = Email.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Email.prototype.url = 'catalogue_functions/send_to_friend_withoutlogo.php';

  Email.prototype.save = function() {
    var def,
      _this = this;
    def = $.ajax({
      url: this.url,
      method: 'post',
      data: this.attributes
    });
    return def.done(function() {
      return _this.trigger('sentSuccess');
    });
  };

  return Email;

})(Model);
